import { useCallback } from 'react';

import { useApiGet, useApiPut } from '../common/api/Api.hooks';
import { PaginatedList } from '../common/PaginatedList.interface';
import { Signup } from './Signup.interface';

export function useFindSignup() {
  const { data, ...result } = useApiGet<Signup>('signup');
  return { ...result, signup: data };
}

export function useFindSignupById(id: number) {
  const { data, ...result } = useApiGet<Signup>(`signup/${id}`);
  return { ...result, signup: data };
}

export function useUpdateSignup(id: number) {
  const { data, put, ...result } = useApiPut<Signup>(`signup/${id}`);
  const update = useCallback((update: Partial<Signup>) => put(update), [put]);
  return { ...result, signup: data, update };
}

export function useFindSignupList() {
  const { data, ...result } = useApiGet<PaginatedList<Signup>>('signup/list');
  return { ...result, signupList: data };
}
